import React, {useEffect, useState} from 'react'
import { GrUpdate } from "react-icons/gr";
import isEqual from 'lodash/isEqual'; 
//import reduce from 'lodash/reduce'; 
import VisDiv from '../frontend_components/VisDiv';
import {generatedOfferDoc} from '../gestioneDatabase/Docs';
import {FiSave} from 'react-icons/fi'
import CheckIcon from '../frontend_components/CheckIcon';
import { set } from 'lodash';


const UpdateOfferFromRegister = ({reportData, offerData, addFields = () => {}}) => {
      
    const [viewToAdd, setViewToAdd] = useState(false)
    const sortBySortKey = ( a, b ) => {

        return a?.sortKey?.toString()?.localeCompare(b?.sortKey?.toString(), undefined, {
    
          numeric: true,
          sensitivity: 'base'
        })}
    
    const reportDataWithKey = !Array.isArray(reportData) ? [] : reportData?.map?.((item)=>{
      return ({
        ...item,
        sortKey: item?.customerProductId + item?.deviceId + item?.nonConformityId
      })
    })

    const compareObject = (obj = {}) =>{ 
        const {customerProductId, nonConformityId, deviceId, offerPropertyId, deviceFamilyId, } = obj
        return ( {customerProductId, offerPropertyId, deviceId, nonConformityId, deviceFamilyId, sortKey: customerProductId + deviceId + nonConformityId } ) 
      } 
      const compareArray = (array=[]) => {
        return array?.map?.((x)=>compareObject(x))?.sort(sortBySortKey)
      }
      const filteredOfferData = !Array.isArray(offerData) ? [] : offerData?.filter?.((x)=>!x?.isManual && !x?.addedLocation)
      //const manualOrAddedLocationOfferData = !Array.isArray(offerData) ? [] : offerData?.filter?.((x)=>x?.isManual || x?.addedLocation)

      const checkData = {
        reportAndOfferAreEqual: isEqual(compareArray(reportData), compareArray(filteredOfferData)),
        reportData,
        compareReportData: compareArray(reportData),
        offerData,
        compareOfferData: compareArray(filteredOfferData)
      }
      const newOfferFieldsToAdd = (checkData) => {

        return checkData?.compareReportData?.map?.((item)=>{
          const findItem = checkData?.compareOfferData?.find?.((x)=>x?.sortKey == item?.sortKey)
          const getFullObject = reportDataWithKey?.find?.((x)=>x?.sortKey == item?.sortKey)
/*           console.log("Processing item:", {
            item,
            findItem,
            getFullObject,
            sortKey: item?.sortKey
          }) */
         if(!findItem && getFullObject?.registerId == "f7a3a346-5880-4c15-9133-45e4936a609d"){
/*             console.log("Adding new fields:", {
              reportData: checkData?.compareReportData,
              offerData: checkData?.compareOfferData,
              findItem,
              item,
              getFullObject,
              reportDataWithKey
            }) */
          } 
          if(!findItem) return getFullObject
          return undefined
        })?.filter?.((x)=>x)
      }

      const [addedOfferFields, setAddedOfferFields] = useState(newOfferFieldsToAdd(checkData))

      useEffect(() => {
        if(!checkData){
          setAddedOfferFields(newOfferFieldsToAdd(checkData))
        }
      }, [checkData])
    
      const updateOfferFromRegister = (e) => {
        e.stopPropagation()
        function getObjectDiff(obj1, obj2) {
            const diff = Object.keys(obj1).reduce((result, key) => {
                if (!obj2.hasOwnProperty(key)) {
                    result.push(key);
                } else if (isEqual(obj1[key], obj2[key])) {
                    const resultKeyIndex = result.indexOf(key);
                    result.splice(resultKeyIndex, 1);
                }
                return result;
            }, Object.keys(obj2));
        
            return diff;
        }
        console.log("updateOfferFromRegister", {
          checkData, 
          addedOfferFields, 
          newOfferFieldsToAdd: newOfferFieldsToAdd(checkData), 
          objectDiff: getObjectDiff(checkData?.compareOfferData, checkData?.compareReportData)
        })
        console.log("Adding fields:", addedOfferFields)
        addFields(addedOfferFields)
        setViewToAdd(false)
      }

  return (
    <div>
        <VisDiv rules={[!checkData?.reportAndOfferAreEqual]} className='round-back-button' style={{backgroundColor:"white", display:"flex", flexDirection:"column"}} onClick={(e) => {e.stopPropagation(); setViewToAdd(!viewToAdd)}}> 
          <GrUpdate fontSize={30} />
        </VisDiv>
        <VisDiv rules={[viewToAdd]}>
        {
            !Array.isArray(newOfferFieldsToAdd(checkData)) ? [] : newOfferFieldsToAdd(checkData)?.map?.((item, index)=>{
              return (
                <AddProductPin
                  key={index}
                  data={{
                    offerField: item,
                    addedOfferFields,
                    setAddedOfferFields: setAddedOfferFields
                  }}
                />
              )})

          }
          <button type='button' className='round-back-button' style={{backgroundColor:"green"}} onClick={updateOfferFromRegister}>
              <FiSave            
              size={15}
              color={"white"}/>
          </button>
        </VisDiv>
    </div>
  )
}

export default UpdateOfferFromRegister

export const AddProductPin = ({data = {}}) => {
 const {offerField, addedOfferFields, setAddedOfferFields} = data
 const isInAddedOfferFields = addedOfferFields?.some?.((x)=>x?.sortKey == offerField?.sortKey)
 const onPinClick = (e) => {
   e.stopPropagation()
   console.log("ON PIN CLICK", offerField)
   if(isInAddedOfferFields){
     setAddedOfferFields(addedOfferFields?.filter?.((x)=>x?.sortKey !== offerField?.sortKey))
   } else {
     setAddedOfferFields([...addedOfferFields, offerField])
   }
  }
 
  return (
              <div onClick={onPinClick} style={{display:"flex", alignItems:"center", margin:"10px", padding:"2px", borderBottom:"1px solid #CCC", borderTop:"1px solid #CCC"}}>
                  <CheckIcon
                        status={isInAddedOfferFields}
                  />
                  <div style={{marginLeft:"10px"}}>
                    {offerField?.customerProduct}
                  </div>
                 
                </div>
  )
}
